export enum TranslationsTarget {
  WEB = 'WEB',
  GUEST = 'GUEST',
  COCKPIT = 'COCKPIT',
}
